/* eslint-disable react-hooks/exhaustive-deps */

import { FilterTask, TaskList } from "pages/Task/types"
import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"

type UseTaskList = {
  params: FilterTask
  /** Board: jangan kirim page/limit ke BE → semua task (sesuai kontrak BE). */
  fetchAllForBoard?: boolean
  onSuccess?: (paging: Response["pagination_data"]) => void
}

type Response = {
  payload: TaskList[]
  pagination_data: {
    total: number
    page: number
    size: number
    pages: number
  }
}

export function useTaskList({
  params,
  fetchAllForBoard = false,
  onSuccess
}: UseTaskList) {
  const api = useApi()
  const [data, setData] = useState<TaskList[]>([])
  const [paging, setPaging] = useState<
    Response["pagination_data"] & { limit: number }
  >()
  const [isLoading, setLoading] = useState(true)

  const fetchData = (options?: { silent?: boolean }) => {
    const silent = options?.silent === true
    if (!silent) setLoading(true)

    const { keyword, page, limit, ...rest } = params
    const payload: Record<string, unknown> = {
      ...rest,
      search: keyword?.trim() ? keyword.trim() : undefined,
      task_status: params.task_status === "0" ? undefined : params.task_status,
      priority: params.priority === "0" ? undefined : params.priority
    }
    if (!fetchAllForBoard) {
      payload.page = page
      payload.limit = limit
    }

    api
      .get("/task/", { params: payload as object })
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? []
        const paging = res.data.pagination_data

        setData(data)
        setPaging({ ...paging, limit: params.limit })
        onSuccess?.(paging)
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData({ silent: true })

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(false)
    }
  }, [
    fetchAllForBoard,
    params.limit,
    params.page,
    params.task_status,
    params.priority,
    params.keyword
  ])

  return {
    data,
    paging,
    isLoading,
    refetch
  }
}
